
export function loadLabelForEdit () {
    this.labelForEdit = this.env.getPageInfo('/admin/marketing/custom-labels/edit/');
}

export function saveLabelForEdit () {
    this.env.setPageInfo('/admin/marketing/custom-labels/edit/', this.labelForEdit);
}
